let promiseListeners = [];

export const reduxPromise = (executor, successActionTypes, errorActionTypes) => {
  let resolve;
  let reject;
  let completed = false;
  const successActionType = successActionTypes || [];
  const errorActionType = errorActionTypes || [];
  const promise = new Promise((resolve_, reject_) => {
    resolve = resolve_;
    reject = reject_;
    const actionListener = (action) => {
      // returns false if it should be removed from the list
      if (completed) return false;
      if (successActionType.indexOf(action.type) >= 0) {
        resolve();
        return false;
      }
      if (errorActionType.indexOf(action.type) >= 0) {
        reject();
        return false;
      }
      return true;
    };
    promiseListeners.push(actionListener);
    if (executor) executor(resolve_, reject_);
  });
  promise.finally(() => {
    completed = true;
  });
  return promise;
};

export const promiseResolverMiddleware = () => (next) => (action) => {
  next(action);
  promiseListeners = promiseListeners.filter((actionListener) => actionListener(action));
};
